import Page from 'rui/widgets/Page'
import Thin from 'components/layout/Thin'
import Panel, { PanelHeading, PanelSubheading } from 'components/layout/Panel'
import { Body2 } from 'components/layout/text'
import hourglassImage from 'images/hourglass.png'
import { Button, Container, Spacer } from 'roadie-ui'

import { ExternalLink } from 'components/layout/links'
import styled from 'styled-components'
import { useDispatch, useSelector } from 'react-redux'
import { AccountSetting, DrivingProfile } from 'types/profile'
import { setMarketingCommOptIn } from 'actions/profile'
import SectionMessage from 'components/layout/SectionMessage'
import { LocalizedRichText, useLocalization, LocalizedText } from 'localization'

const Img = styled.img``

const getIfOptedInToMarketingComm = (accountSettings: AccountSetting[]) => {
  const marketingCommOptInList = accountSettings.filter((item) => item.setting === 'marketing_comm_opt_in')
  const marketingCommOptIn = marketingCommOptInList[0]

  return marketingCommOptIn.value == 'true'
}

const BlockedMessagePage = () => {
  const { t } = useLocalization()
  const accountSettings = useSelector<any, AccountSetting[]>((state) => state.accountSettings)
  const profile = useSelector<any, DrivingProfile>((state) => state.profile)
  const dispatch = useDispatch()

  const isOptedInToMarketingComm = getIfOptedInToMarketingComm(accountSettings)
  const handleMarketingCommOptIn = async () => {
    try {
      setMarketingCommOptIn(profile.id, true)(dispatch)
    } catch (_) {
      dispatch({
        type: 'PUSH_FLASH',
        flash: {
          messageKey: 'dweb_flash_sms_notifications_enable_problem',
          type: 'alert',
        },
      })
      throw new Error()
    }
  }

  return (
    <Page>
      <Thin>
        <Panel>
          <PanelHeading>
            <LocalizedText translationKey="dweb_blocked_message_youre_list" />
          </PanelHeading>
          <PanelSubheading>
            <LocalizedText translationKey="dweb_blocked_message_thanks_interest_driving_roadie_youve_been_added_waitlist" />
          </PanelSubheading>

          <Spacer $height="1.6rem" />
          <Img src={hourglassImage} />
          <Spacer $height="1.6rem" />

          <Body2 align="left" weight="bold">
            <LocalizedText translationKey="dweb_blocked_message_how_does_waitlist_work" />
          </Body2>
          <Body2 align="left">
            <LocalizedText translationKey="dweb_blocked_message_we_limit_number_drivers_certain_areas_match_delivery" />
          </Body2>
          <Spacer $height="1.6rem" />
          <Body2 align="left">
            <LocalizedRichText
              translationKey="dweb_blocked_message_get_more_details_about_waitlist_link1"
              params={{
                link1: (
                  <ExternalLink
                    href={`${
                      import.meta.env.REACT_APP_SUPPORT_URL
                    }/support/s/article/Driver-Gig-logistics-What-waitlists-mean`}
                    $letterSpacing="0"
                  >
                    <LocalizedText translationKey="dweb_common_here" />
                  </ExternalLink>
                ),
              }}
            />
          </Body2>
          <Spacer $height="1.6rem" />
          <Body2 align="left" weight="bold">
            <LocalizedText translationKey="dweb_blocked_message_how_long_can_i_expect_waitlist" />
          </Body2>
          <Body2 align="left">
            <LocalizedText translationKey="dweb_blocked_message_waitlist_times_vary_by_area_seasonal_demands_most" />
          </Body2>
          <Spacer $height="1.6rem" />
          <Body2 align="left" weight="bold">
            <LocalizedText translationKey="dweb_blocked_message_how_will_i_notified_when_im_off_waitlist" />
          </Body2>
          <Body2 align="left">
            <LocalizedText translationKey="dweb_blocked_message_receive_instant_alerts_marketing_updates_turn_sms_notifications" />
          </Body2>
          <Spacer $height="1.6rem" />

          <Container.Grid $display="flex" $justifyContent="center">
            {isOptedInToMarketingComm ? (
              <SectionMessage
                description={t('dweb_blocked_message_sms_notifications')}
                iconType="success"
                maxWidth="75%"
              />
            ) : (
              <Button.Primary onClick={handleMarketingCommOptIn} $padding="1.2rem 1.6rem" $width="100%">
                <LocalizedText translationKey="dweb_blocked_message_turn_sms" />
              </Button.Primary>
            )}
          </Container.Grid>

          <Spacer $height="1.6rem" />
          <Body2 align="left" weight="bold">
            <LocalizedText translationKey="dweb_blocked_message_how_can_i_update_my_information" />
          </Body2>
          <Body2 align="left">
            <LocalizedText translationKey="dweb_blocked_message_youll_able_update_information_app_once_youre_off" />
          </Body2>
          <Spacer $height="1.6rem" />
        </Panel>
      </Thin>
    </Page>
  )
}

export default BlockedMessagePage
